$('.case-studies-block .filter .current-item').click(function(e) {
    e.preventDefault();

    const $this = $(this);
    $this.parent().toggleClass('open');
});

var $caseStudiesArchive = $('.case-studies-block');
var $primary = $('.case-studies-block .primary');
var $filter = $('.case-studies-block .filter');

if ($('.case-studies-block').length > 0) {

    var filterTop = $filter.offset().top;

    $(window).scroll(function(e) {
        var scrollTop = $(this).scrollTop();
        var primaryHeight = $primary.height();
        var marginTop = $caseStudiesArchive.css('marginTop').replace('px', '');

        if (scrollTop > filterTop - 64) {
            $filter.addClass('sticky');
        } else {
            $filter.removeClass('sticky');
        }

        if (scrollTop > primaryHeight) {
            $filter.css('transform', 'translateY(-' + (scrollTop - primaryHeight - marginTop / 2) + 'px)');
        }
    });
}